import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SendIcon(props: IconProps) {
    return <Icon {...props} iconKey={"send"}/>
}
